export default function getValidHref(value: string, type: string) {
  switch (type) {
    case "email":
      return `mailto:${value}`;
    case "call":
      return `tel:${value}`;
    default:
      return value;
  }
}

// These open an app on the device instead of a page, so a new tab would stay blank.
export function isSelfTarget(type: string) {
  return type === "email" || type === "call" || type === "sms";
}
